$(function() {
  if ($('#create-edit-pages').length === 0) return

  const slugify = require('@sindresorhus/slugify')

  $('input[name="title"]').keyup(function(event) {
    if ($('#auto-url').is(':checked')) {
      $('input[name="url"]').val(slugify($('input[name="title"]').val()))
    }
  })
})
